import React from 'react';

function AuthorAvatar({ name, imgSrc, size = 26 }) {
  if (imgSrc) {
    return (
      <img
        src={imgSrc}
        alt={name}
        style={{ width: size, height: size }}
        className="rounded-full object-cover border-2 border-crimson"
      />
    );
  }
  const letter = (name || '?').trim().charAt(0).toUpperCase();
  return (
    <span
      className="inline-flex items-center justify-center rounded-full bg-crimson text-white font-bold flex-shrink-0"
      style={{ width: size, height: size, fontSize: size * 0.45 }}
    >
      {letter}
    </span>
  );
}

export default AuthorAvatar;
